import React from 'react'
import type { FC } from 'react'
interface Props {
  className?: string;
  color?: string;
  size?: number | string;
  rotateOnRtl?: boolean;
}
export const IconEmail: FC<Props> = ({
  color = 'currentColor',
  size = 24,
  className,
  rotateOnRtl = false,
  ...rest
}) => {
  const props = {
    width: size,
    height: size,
    fill: color,
    // stroke: color,
    className,
    viewBox: '0 0 24 24',
    ['data-rotateonrtl']: false,
    ...rest,
  }
  return /*#__PURE__*/ React.createElement(
    'svg',
    Object.assign(
      {
        width: 24,
        height: 24,
        viewBox: '0 0 24 24',
        xmlns: 'http://www.w3.org/2000/svg',
      },
      props
    ),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M22 6C22 5.4 21.6 5 21 5H3C2.4 5 2 5.4 2 6V19C2 19.1 2 19.3 2.1 19.4C2.2 19.6 2.4 19.8 2.6 19.9C2.7 20 2.9 20 3 20H21C21.1 20 21.3 20 21.4 19.9C21.6 19.8 21.8 19.6 21.9 19.4C22 19.3 22 19.1 22 19V6ZM4 8.3L8.4 12.2L8.3 12.3L4 16.6V8.3ZM12 12.7L5.6 7H18.5L12 12.7ZM9.7 13.7C9.8 13.6 9.8 13.5 9.9 13.5L11.4 14.8C11.5 14.9 11.8 15 12 15C12.2 15 12.5 14.9 12.7 14.8L14.2 13.5C14.2 13.6 14.3 13.7 14.4 13.7L18.7 18H5.4L9.7 13.7ZM15.7 12.3L15.6 12.2L20 8.3V16.6L15.7 12.3Z',
    })
  )
}
